<template>
  <div class="q-gutter-md">
      <q-card class="q-pa-md">
        <div class="text-h6 q-mb-md">Export Options</div>
        <div class="row q-gutter-sm q-mb-md">
          <q-btn color="primary" icon="file_download" label="Download TTL" @click="emit('download-ttl')" />
          <q-btn color="secondary" icon="code" label="View Raw TTL" @click="emit('show-raw-ttl')" />
          <q-btn color="info" icon="share" label="Copy TTL URL" @click="emit('copy-ttl-url')" />
        </div>
      </q-card>

      <q-card class="q-pa-md">
        <div class="text-h6 q-mb-md">TTL Preview</div>
        <q-input
          :model-value="ttlPreview"
          type="textarea"
          rows="15"
          readonly
          filled
          class="text-code"
          style="font-family: monospace; font-size: 12px;"
          placeholder="Click 'Preview TTL' to load content..."
          @update:model-value="emit('update:ttlPreview', $event)"
        />
      </q-card>
  </div>
</template>

<script setup>
  import { defineProps, defineEmits } from 'vue';

  const props = defineProps({
    ttlPreview: {
      type: String,
      default: '',
    },
  });

  const emit = defineEmits([
    'update:ttlPreview',
    'download-ttl',
    'show-raw-ttl',
    'copy-ttl-url',
  ]);
</script>

<style scoped>
.text-code {
  /* Monospace styling for code display */
}
</style>
